import { useCustomMutation, useLogout, useTranslate } from "@refinedev/core";
import { useAnalytics } from "hooks/useAnalytics";
import { AnalyticsEvents } from "types/analytics";
import { message } from "antd";

export default function useDeleteAccount() {
  const { mutateAsync: deleteAccount, isPending: isLoadingDelete } =
    useCustomMutation();
  const { mutate: logout } = useLogout();
  const t = useTranslate();
  const { trackEvent } = useAnalytics();

  const deleteApiUser = async () => {
    return await deleteAccount({
      url: "/api/users/me",
      method: "delete",
      values: {},
      errorNotification: {
        type: "error",
        message: t("pages.user.delete.failedToDeleteAccount"),
      },
    });
  };

  const handleDeleteAccount = async () => {
    try {
      await deleteApiUser();

      trackEvent(AnalyticsEvents.UserDeleted, {});
      logout();
    } catch (error) {
      console.error("Error deleting account", error);
      message.error(t("pages.user.delete.errorDeletingAccount"));
      throw error;
    }
  };

  return {
    handleDeleteAccount,
    isLoading: isLoadingDelete,
  };
}
